import { TYPE } from './defConstants'

/**
 * OFM-222: 검색(OpenSearch) 결과의 표시·동작 단위를 판정하는 순수 함수.
 *
 * MainDef의 `this.mailbox`(및 ThreadView의 `curMailbox`)는 검색 진입 시에도 원본 폴더
 * mailbox(THREAD)를 유지하는 반면, 실제 목록은 `dataManager.searchMailbox` 기준으로 그려진다.
 * 이 불일치 때문에 표시/명령 단위를 소비 시점에 searchMailbox 기준으로 다시 질의해야 한다.
 *
 * - OPEN_SEARCH 검색: `getListType()`이 `TYPE.EMAIL`을 강제 → `true`(개별 이메일 단위)
 * - JMAP 등 비 OPEN_SEARCH 검색: `getListType()`이 innerMailbox/설정으로 위임되어 `TYPE.THREAD`
 *   → `false`(스레드 동작 보존, 전방 호환)
 * - 검색 모드가 아니거나 searchMailbox가 없으면: `false`
 */
export interface SearchModeQuery {
  isSearchMode: () => boolean
  getListType: () => unknown
}

export const isSearchEmailMode = (searchMailbox: SearchModeQuery | null | undefined): boolean => {
  return (
    searchMailbox != null &&
    searchMailbox.isSearchMode() === true &&
    searchMailbox.getListType() === TYPE.EMAIL
  )
}
